import { SearchVisibility } from './advanced/SearchVisibility';
import { ISearch, SearchContext } from './ISearch';

export abstract class BaseSearch<T> implements ISearch {
  public id: string;
  public name: string;
  public expression: T;
  public dirty: boolean;
  public context: SearchContext;
  public visibility: SearchVisibility;
  public readonly createdBy: String;
  public accounts: string[];
  public roles: string[];

  public constructor(context, expression: T) {
    this.expression = expression;
    this.dirty = false;
    this.context = context;
  }
}
